module.exports = __webpack_public_path__ + "img/logo.a2e2c9ed.svg";